import { SVGProps } from 'react';

const TrafficCone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.05 10.966c-.464.32-1.072.58-1.776.76A9.3 9.3 0 0 1 12 12c-.79 0-1.57-.094-2.274-.273s-1.312-.44-1.776-.76m8.973 3.082 4.48 2.04a1 1 0 0 1 .001 1.831l-8.574 3.9a2 2 0 0 1-1.66 0l-8.574-3.91a1 1 0 0 1 0-1.83l4.484-2.04m2.114-7.47c.828.28 1.805.43 2.805.43s1.977-.15 2.805-.43m2.145 7.57c.101.354.049.716-.154 1.06-.202.343-.55.66-1.02.931-.469.27-1.049.487-1.7.636a9.4 9.4 0 0 1-2.076.226 9.4 9.4 0 0 1-2.076-.226c-.651-.149-1.231-.366-1.7-.636-.47-.27-.818-.588-1.02-.932-.203-.343-.255-.704-.154-1.059L10.063 3.5a2 2 0 0 1 3.874 0z"
    />
  </svg>
);
export default TrafficCone;
